import { render } from "./FormCheckbox.vue?vue&type=template&id=ef30f648&scoped=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"

import "./FormCheckbox.vue?vue&type=style&index=0&id=ef30f648&lang=scss&scoped=true"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef30f648"]])

export default __exports__